import { render, staticRenderFns } from "./ManualFulfillmentCard.vue?vue&type=template&id=89d64090&scoped=true"
import script from "./ManualFulfillmentCard.vue?vue&type=script&lang=js"
export * from "./ManualFulfillmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d64090",
  null
  
)

export default component.exports